import * as React from 'react';
import useStyles from './MockAuth0TextField.styles';
import { ReactElement } from 'react';
import clsx from 'clsx';

export interface IMockAuth0TextFieldProps {
  placeHolder?: ReactElement;
  inputText?: ReactElement;
  isOld?: boolean;
}

const MockAuth0TextField: React.FC<IMockAuth0TextFieldProps> = ({
  placeHolder,
  inputText,
  isOld,
}) => {
  const classes = useStyles();

  return (
    <div className={isOld ? clsx(classes.root, classes.oldRoot) : classes.root}>
      {placeHolder && <div className={classes.header}>{placeHolder}</div>}
      {inputText}
    </div>
  );
};

export default MockAuth0TextField;
